import React, { useEffect, useState } from "react";
import { Button, Divider, TextField } from "@mui/material";
import { Add } from "@mui/icons-material";
import jsonrepair from "jsonrepair";
import localize from "../../../common/localize";
import useGlobalContext from "../../../hooks/useGlobalContext";
import {
  getInputLabelProps,
  getInputProps,
  PopperFullWidth,
} from "../../../common/appStyles";
import Combobox from "../../../components/common/Combobox";
import TableComponent from "../../../components/common/TableComponent";
import ActionButtons from "../../../components/common/ActionButtons";
import ErrorMessage from "../../../components/common/ErrorMessage";

import {
  generateNoDataValues,
  getProfileNameByForm,
  getRestrictionNameByRestrictionKey,
} from "../../../common/utils";
import { getProfiles } from "../../../common/EntitiesManagement";
import NotificationItem from "../../../components/common/NotificationItem";

export default function AddOrEditProfile() {
  const { profileModel, setProfileModel, profileModules, setProfileModules } =
    useGlobalContext();

  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);

  const [selectedModule, setSelectedModule] = useState(null);

  const handleModuleChange = (value) => {
    if (!value) {
      setSelectedModule(null);
    }
    setSelectedModule(value);
  };

  const handleChange = (e) => {
    setProfileModel({
      ...profileModel,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModule = () => {
    if (
      profileModules.filter(
        (profileModule) => profileModule.Form === selectedModule.Form
      ).length === 0
    ) {
      setProfileModules([...profileModules, selectedModule]);
      setSelectedModule(null);
    }
    setSelectedModule(null);
  };

  const handleDeleteProfileModule = (moduleObj) => {
    setProfileModules(
      profileModules.filter(
        (profileModule) => profileModule.Form !== moduleObj.Form
      )
    );
  };

  useEffect(() => {
    if (profileModel?.Id) {
      setProfileModules(JSON.parse(jsonrepair(profileModel.Description)));
    }
  }, [profileModel]);

  return (
    <div style={{ width: "100%" }}>
      {showErrorModal && (
        <ErrorMessage
          message={errorMessage}
          title={localize.error_unexpected}
          showModal={showErrorModal}
          setShowModal={setShowErrorModal}
        />
      )}

      <form className="w-full mt-2 flex flex-col gap-2">
        <div className="mb-4">
          <TextField
            required
            InputLabelProps={getInputLabelProps()}
            inputProps={getInputProps()}
            size="small"
            fullWidth
            name="Name"
            id="Name"
            value={profileModel.Name}
            label={localize.name}
            variant="outlined"
            onChange={handleChange}
          />
        </div>

        <div className="flex items-center w-full gap-2">
          <Combobox
            id="Module"
            fieldLabel={localize.module}
            fieldOptions={getProfiles()}
            fieldValue={selectedModule}
            customOptionLabel={(option) => getProfileNameByForm(option.Form)}
            handleValueChange={handleModuleChange}
            popperFullWidth={PopperFullWidth}
          />
          <div>
            <Button
              disabled={!selectedModule}
              size="small"
              variant="contained"
              color="success"
              className="app_general_button_data app_success_button btn-sm"
              onClick={handleAddModule}
            >
              <span className="mr-2">{localize.add}</span>
              <Add className="text-lg" />
            </Button>
          </div>
        </div>

        <Divider />

        <div className="my-2">
          {profileModules?.length > 0 ? (
            <TableComponent
              noPadding
              firstColumnTitle={localize.actions}
              columnTitles={[localize.module, localize.restriction]}
              results={
                profileModules?.length > 0
                  ? profileModules?.map((moduleObj) => ({
                      key: moduleObj.Form,
                      data: [
                        <ActionButtons
                          hideEditButton
                          onclickForDeleteButton={(e) => {
                            e.preventDefault();
                            handleDeleteProfileModule(moduleObj);
                          }}
                        />,
                        getProfileNameByForm(moduleObj.Form),
                        getRestrictionNameByRestrictionKey(
                          moduleObj.Restriction
                        ),
                      ],
                    }))
                  : [generateNoDataValues(3)]
              }
            />
          ) : (
            <NotificationItem notification={{ message: localize.no_restrictions }} />
          )}
        </div>
      </form>
    </div>
  );
}
